<template>
    <v-layout>
        <v-flex xs12 pa-2 class="group_Request__item-form">
            <v-form ref="form" v-model="fieldsValid">
                <v-text-field
                    id="group_name"
                    :counter="50"
                    :rules="nameRules"
                    v-model="groupRequest.groupName"
                    :disabled="isSubmitting"
                    :label="groupConstants.GROUP_NAME"
                    data-qe-id="group-request_name_input"
                    autofocus
                    required>
                </v-text-field>
                <v-select
                    attach
                    v-model="groupRequest.focusId"
                    :items="getGroupFocus"
                    item-text="name"
                    item-value="id"
                    data-qe-id="group-request_focus_dropdown"
                    :rules="[v => !!v || groupConstants.VALIDATIONS.ITEM_REQUIRED]"
                    :disabled="isSubmitting"
                    :label="groupConstants.FOCUS"
                    v-on:change="getGroupSubFocus"
                    required>
                </v-select>
                <v-select
                    attach
                    v-model="groupRequest.subFocusId"
                    :items="getGroupSubFocusItems"
                    item-text="name"
                    item-value="id"
                    data-qe-id="group-request_sub-focus_dropdown"
                    :rules="[v => !!v || groupConstants.VALIDATIONS.ITEM_REQUIRED]"
                    :disabled="isSubmitting"
                    :label="groupConstants.SUB_FOCUS"
                    required>
                </v-select>
                <h6>
                    {{groupConstants.PRIVACY}}
                </h6>

                <v-radio-group
                    :disabled="isSubmitting"
                    v-model="groupRequest.groupSecurity"
                    :rules="[v => !!v || groupConstants.VALIDATIONS.ITEM_REQUIRED]"
                    required>
                    <v-radio :value="groupConstants.PUBLIC" data-qe-id="group-request_type-public">
                        <div slot="label">
                            <p><em><i class="fas fa-lock-open"></i> {{groupConstants.PUBLIC}}</em> - <span class="groupRequestRadio">{{groupConstants.PUBLIC_GROUP}}</span></p>
                        </div>
                    </v-radio>
                    <v-radio :value="groupConstants.PRIVATE" data-qe-id="group-request_type-private">
                        <div slot="label">
                            <p><em><i class="fas fa-lock"></i> {{groupConstants.PRIVATE}}</em> - <span class="groupRequestRadio">{{groupConstants.PRIVATE_GROUP}}</span></p>
                        </div>
                    </v-radio>
                    <v-radio :value="groupConstants.SECRET" data-qe-id="group-request_type-secret">
                        <div slot="label">
                            <p><em><i class="fa fa-lock"></i> {{groupConstants.SECRET}}</em> - <span class="groupRequestRadio">{{groupConstants.SECRET_GROUP}}</span></p>
                        </div>
                    </v-radio>
                </v-radio-group>
                <div class="description">
                    <strong>{{groupConstants.DESCRIPTION}}</strong>
                    <v-textarea
                        v-model="groupRequest.groupDescription"
                        :name="groupConstants.DESCRIPTION"
                        counter="256"
                        data-qe-id="group-request_description_input"
                        :disabled="isSubmitting"
                        :rules="[v => (!!v && v.length <= 256) || groupConstants.VALIDATIONS.DESCRIPTION_ERROR]">
                    </v-textarea>
                </div>
                <v-flex class="terms">
                    <a :href="groupConstants.TandC_DOCUMENT" class="TAndCLink" target="_blank">{{groupConstants.TERMS_CONDITION}}</a>
                    <v-checkbox :disabled="isSubmitting" v-model="termsAndCondition"
                                data-qe-id="group-request_terms-and-condition_checkbox"
                                :label="groupConstants.TERMS_CONDITION_CHECK"></v-checkbox>
                </v-flex>
                <v-layout row wrap class="dailog-footer">
                    <v-flex xs12 sm12 md4>
                        <span class="error-message">{{errorMessage}}</span>
                    </v-flex>
                    <v-flex xs12 sm12 md8 text-xs-right>
                        <div class="button-group1">
                            <v-btn class="primary_btn transparent" :disabled="isSubmitting"
                                   data-qe-id="group-request_cancel_btn"
                                   @click="resetForm">
                                {{groupConstants.CANCEL}}
                            </v-btn>
                            <v-btn
                                :disabled="!formValid || isSubmitting || errorMessage.length > 0"
                                :loading="isSubmitting"
                                class="primary_btn"
                                data-qe-id="group-request_confirm_btn"
                                @click="requestGroup">
                                {{ groupConstants.REQUEST_GROUP }}
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-flex>
        <v-dialog
            v-model="showInfo"
            lazy
            absolute
            content-class="extra-small">
            <v-card class="showgroup-popup">
                <v-card-title>
                    <v-icon @click="hidePopup()" data-qe-id="close_dialog_btn">fas fa-times</v-icon>
                </v-card-title>
                <v-card-text v-html="alertMessage"></v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { groupConstants } from '../GroupPage/groupConstant';
    import { mapActions, mapGetters } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";

    export default {
        name: 'GroupRequest',
        created() {
            this.getFocusList();
        },
        data() {
            return {
                requestNumber: 0,
                groupConstants,
                messageType: '',
                alertMessage: '',
                isSubmitting: false,
                termsAndCondition: false,
                fieldsValid: false,
                validReason: false,
                groupSubFocusItems: [],
                showInfo: false,
                getGroupSubFocusItems: [],
                alreadyExistingNames: [],
                submitError: '',
                nameRules: [
                    v => !!v || groupConstants.VALIDATIONS.NAME_REQUIRED,
                    v => (!!v && v.length <= 50) || groupConstants.VALIDATIONS.NAME_LENGTH_VALIDATION,
                ],
                groupRequest: {
                    groupSecurity: groupConstants.PUBLIC,
                    groupName: '',
                },
            };
        },
        methods: {
            ...mapActions({
                getFocusList: `group/${storeAction.getFocusList}`,
                getGroupConfiguration: `group/${storeAction.getGroupConfiguration}`,
                requestGroupPost: `group/${storeAction.requestGroupPost}`,
                reviewRequest: `group/${storeAction.reviewRequest}`,
                getPendingRequestList: `group/${storeAction.getPendingRequestList}`,
            }),
            requestGroup() {
                if (this.$refs.form.validate()) {
                    this.isSubmitting = true;
                    this.requestGroupPost({
                        groupObject: JSON.parse(JSON.stringify(this.groupRequest)),
                        isNewRequestGroup: true,
                    }).then(() => {
                        this.isSubmitting = false;
                        this.messageType = 'success';
                        this.alertMessage = this.groupConstants.VALIDATIONS.CREATION_SUCCESS;
                        this.showInfo = true;
                        gaDataLayerEvent(gtmEventName.C_Connect_New_Group_Request,
                        `${this.groupRequest.groupName} | ${this.groupRequest.groupSecurity}`);
                        this.resetForm();
                    }).catch((error) => {
                        this.isSubmitting = false;
                        if (error.response.data.message.toLowerCase().includes(this.groupConstants.VALIDATIONS.ALREADY_EXSIST)) {
                            this.alreadyExistingNames.push(this.groupRequest.groupName.toLowerCase());
                        } else {
                            this.submitError = error.response.data.message;
                            setTimeout(() => {
                                this.submitError = '';
                            }, 3000);
                        }
                    });
                }
            },
            resetForm() {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                } else {
                    Object.keys(this.groupRequest).forEach((k) => { this.groupRequest[k] = null; });
                }
                setTimeout(() => {
                    this.groupRequest.groupSecurity = this.groupConstants.PUBLIC;
                }, 0);
            },
            hidePopup() {
                this.showInfo = false;
                this.messageType = '';
                this.alertMessage = '';
                this.$emit("close");
            },
            getGroupSubFocus(focusId) {
                if (this.groupFocusList && focusId) {
                    this.groupRequest.subFocusId = null;
                    this.getGroupSubFocusItems = this.groupFocusList.filter(v => v.parentId === focusId);
                }
            },

        },
        computed: {
            ...mapGetters({
                groupConfigRequest: `group/${storeGetters.groupConfigRequest}`,
                pendingRequestList: `group/${storeGetters.pendingRequestList}`,
                groupFocusList: `group/${storeGetters.groupFocusList}`,
                isAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
                groupIdPromise: `${storeGetters.communityIdPromise}`,
                userPermissionsData: `auth/${storeGetters.permissionsData}`,
            }),
            errorMessage() {
                return (this.groupRequest.groupName && this.alreadyExistingNames.includes(this.groupRequest.groupName.toLowerCase())) ? this.groupConstants.VALIDATIONS.GROUPNAME_ALREADY_EXISTS : this.submitError;
            },

            groupRequestorName() {
                return 'First Name Last Name';
            },
            
            getGroupFocus() {
                if (this.groupFocusList) {
                    return this.groupFocusList.filter(v => v.parentId == null);
                }
            },

            formValid() {
                return this.fieldsValid && (
                    this.groupRequest.groupName &&
                    this.groupRequest.groupDescription && this.termsAndCondition
                );
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .TAndCLink {
        text-decoration: none;
        font-weight: bold;
    }

    .showgroup-popup {
        .v-card__title {
            background: $ypo-blue;
            position: relative;
            padding: 20px;

            .v-icon {
                position: absolute;
                color: $white;
                font-size: 16px;
                right: 5px;
                cursor: pointer;
                top: 8px;
            }
        }

        .v-card__text {
            padding: 40px 10px;
            text-align: center;
            font-weight: 600;
        }
    }

    .infoPopup {
        &__popup {
            position: relative;
            font-size: 18px;
            font-weight: bold;
            padding: 40px 200px 40px 200px;
            font-family: Raleway;
        }

        i {
            cursor: pointer;
            position: absolute;
            right: 15px;
            top: 15px;
        }

        &__error {
            color: red;
        }

        &__success {
            color: #083050;
        }
    }

    .rejected-successfully {
        text-align: center;
        padding: 30px 150px;

        i.fa-times-circle {
            font-size: 12px;
            color: $ypo-cta;
            position: absolute;
            right: 5px;
            top: 5px;
            cursor: pointer;
        }
    }

    .reason-denial {
        i.fa-times-circle {
            font-size: 18px;
            color: $ypo-cta;
            position: relative;
            top: 5px;
            right: 5px;
            cursor: pointer;
        }

        strong {
            color: $ypo-blue;

        }

        .v-textarea {
            textarea {
                border: 1px $ypo-medium-gray solid;
                border-radius: 3px;
                padding: 10px;
            }

        }

        .v-text-field>.v-input__control>.v-input__slot:before {
            border: 0;
        }
    }

    .dailog-footer {
        border-top: 1px solid $ypo-medium-gray;
        padding-top: 10px;
        margin-top: 10px;

        .error-message {
            display: block;
            margin-top: 11px;
            white-space: nowrap;
        }

        @include breakpoint(xs) {
           .primary_btn {
               padding: 8px 15px;
           }
           .error-message {
               white-space: inherit !important;
           }
        }
    }
</style>
